import React from 'react';
import { Flex, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { Copy } from '../../../../../../../shared/ui/Copy';
import { botName, webAppName } from '../../../../../../../utils/common/botInfo';
import { StepTitle } from '../../steps/StepTitle';
import { StepList } from '../../steps/StepList';
import { useAppSelector } from '../../../../../../../store';
import { selectShopCurrent } from '../../../../shops/store/shopSlice';

const { Text } = Typography;

export const UnitpayStepInit = () => {
    const current = useAppSelector(selectShopCurrent);

    return (
        <Flex vertical gap={8}>
            <StepTitle text={'Шаг 1. Создание проекта в Unitpay:'} />

            <StepList>
                <Text>
                    1. зарегистрируйтесь/авторизуйтесь в сервисе
                    <Link
                        to={'https://unitpay.ru/signup/legal'}
                        target={'_blank'}
                    >
                        {' '}
                        Unitpay
                    </Link>{' '}
                </Text>
                <Text>2. выберите вкладку "Все проекты"</Text>
                <Text>3. нажмите "Добавить проект"</Text>
                <Text>4. выберите тип проекта Https</Text>
                <Text>
                    5. вставьте ссылку на магазин{' '}
                    <Copy
                        text={`https://t.me/${botName}/
                ${webAppName()}?startapp=${current.id}`}
                    />
                </Text>{' '}
                <Text>6. нажмите "Далее"</Text>
            </StepList>
        </Flex>
    );
};
